import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import React from 'react'

function SelectorTipoPersona({formik}) {
  return (
    <RadioGroup
      row
      aria-labelledby="demo-row-radio-buttons-group-label"
      name="row-radio-buttons-group"
      value={formik.values.personaFisica}
      onChange={formik.handleChange("personaFisica")}
    >
      <FormControlLabel
        value={true}
        control={<Radio />}
        label="Persona física"
      />
      <FormControlLabel
        value={false}
        control={<Radio />}
        label="Persona moral"
      />
    </RadioGroup>
  );
}

export default SelectorTipoPersona   